import Request from "@/shared/utils/_request";
class Resume {
  constructor() { }
  getList(payload) {
    return Request.post("/resume/get-list", payload);
  }
  getDetail(payload) {
    return Request.post("/resume/detail", payload);
  }
  getEditionList(payload) {
    return Request.post("/resume/getMultiListByMobile", payload);
  }

  //添加软性点评
  //用户标签
  getUserTags() {
    return Request.post("/resume/SoftSkillUserTag/getAll");
  }
  /**
   * 添加用户标签
   * @param {{tag_name}} payload
   */
  createUserTag(payload) {
    return Request.post("/resume/SoftSkillUserTag/create", payload);
  }
  /**
   * 删除用户标签
   * @param {{tag_name}} payload
   */
  deleteUserTag(payload) {
    return Request.post("/resume/SoftSkillUserTag/delete", payload);
  }
  softSkill() {
    return Request.post("/resume/soft-skill/get-tree");
  }
  createSoftSkill(payload) {
    return Request.post("/resume/soft-skill/create", payload);
  }
  reportUpdate(payload) {
    return Request.post("/post/report/update", payload);
  }
  //显示软性点评
  getSoftSkillList(payload) {
    return Request.post("/resume/soft-skill/get-list", payload);
  }
  //沟通列表
  getCommunicationList(payload) {
    return Request.post("/resume/CommunicationRecord/get-list", payload);
  }
  //添加沟通记录
  createCommunication(payload) {
    return Request.post("/resume/CommunicationRecord/create", payload);
  }
  //获取沟通记录附件
  getCommunicationAttachment(payload) {
    return Request.post("/resume/CommunicationRecord/attachment", payload);
  }
  /**
   * 获取预览地址
   * @param {{attachment_id}} payload
   */
  generatePreview(payload) {
    return Request.post("/resume/generatePreview", payload);
  }
  /**
   * 下载简历附件
   * @param {{attachment_id}} payload
   */
  downloadResume(payload) {
    return Request.get("/resume/downloadAttachment", payload);
  }
  /**
   * 下载简历报告
   * @param {{resume_id}} payload
   */
  downloadReport(payload) {
    return Request.get("/resume/downloadReport", payload);
  }
}

export const resume = new Resume();
